/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 * @author        Afternet <info@afternet.gr>
 * @copyright   Afternet
 * @license        http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import manufacturerSlider from './sliders/manufacturerSlider';
import {createTabsListingSpin, placeListErrors} from "./front/_front";
import {getProductList, getUnitsData} from "./front/_productListFuctions";

export default function step2Standard() {

    let xhr_getJobTypeValueBrands = null;

    $(document).on('click', '.js-categorySelection-header', function (e){
       e.preventDefault();
    });

    $(document).on('change', '.js-job-type', function (e){
        e.stopPropagation();

        let _value = $('.js-job-type:checked').val();
        let _id_feature = $('.js-job-type:checked').attr('data-id-feature-value');
        if( typeof _id_feature != 'undefined' && _id_feature !=  '' && _id_feature !=  null){
            const data = [{name: "id_afpw_job", value: window.Job.id_afpw_job},{name: "id_feature_value", value: _id_feature}];
            getJobUnits(data);
        }

    });

    function getJobUnits(data){
        $.ajax({
            method: "POST",
            url: afpw_ajax_url,
            beforeSend: function () {
                if(xhr_getJobTypeValueBrands != null){ xhr_getJobTypeValueBrands.abort(); }
                if($('.js-job-units').length){
                    $('.js-job-units').remove();
                }
                if($('.js-jobTypeValueBrands').length){
                    $('.js-jobTypeValueBrands').remove();
                }
                if($('.js-jobProductList').length){
                    $('.js-jobProductList').remove();
                }
                if($('.js-kx-flow .alert').length){
                    $('.js-kx-flow .alert').remove();
                }
                $('.js-kx-flow').append('<div class="kx-loader"></div>');
            },
            cache: false,
            data: {
                ajax: true,
                action: 'getJobUnits',
                hash: afpw_hash,
                data: $.param(data)
            },
        }).done(function (data, textStatus, jqXHR){
            try {
                var obj = jQuery.parseJSON(data);
                if (obj.status == 'success') {
                    if($('.js-jobTypeValueBrands').length){
                        $('.js-jobTypeValueBrands').remove();
                    }
                    $('.js-kx-flow').append(obj.html);
                    $('.js-jobUnits-subtitle').html(window.Job.title_dimension_form);
                    $('.js-jobUnits-description').html(window.Job.description_dimension_form);

                    //$('.js-job-units').get(0).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
                    if($('.js-job-units').length){
                        var _top = $('.js-job-units').offset().top;
                        window.scrollTo({
                            top: _top - 110,
                            behavior: "smooth"
                        });
                    }

                } else {
                    if (typeof(obj.errors) != 'undefined' ) {
                        $.each(obj.errors, function(key,value) {
                            placeListErrors(value);
                        });
                    }
                }

            } catch (error) {
                console.log(error);
            }
        }).fail(function(jqXHR, textStatus, errorThrown) {
            placeListErrors('Συνέβη ένα λάθος παρακαλώ δοκιμάστε αργότερα');
            console.log(errorThrown);
        }).always(function() {
            xhr_getJobTypeValueBrands = null;
            $('.kx-loader').remove();
        });
    }

}


